// Import entity modules
import { User } from './user';
import { Company } from './company';
import { Campaign } from './campaign';
import { Partition } from './partition';
import { Device } from './device';
import { Deal } from './deal';
import { Contact } from './contact';
import { Auth } from './auth';
import { ContactUs } from './contactUs';

import { Session } from './session';
export * from './utils';

// Define mount paths
const userMountPath = 'users';
const companyMountPath = 'companies';
const campaignMountPath = 'campaigns';
const partitionMountPath = 'partitions';
const deviceMountPath = 'devices';
const contactMountPath = 'contacts';
const dealMountPath = 'deals';
const contactUsMountPath = 'contact-us';
const authMountPath = 'auth';
const sessionMountPath = 'session';

// Export APIs centrally
export const userService = new User(userMountPath);
export const companyService = new Company(companyMountPath);
export const campaignService = new Campaign(campaignMountPath);
export const partitionService = new Partition(partitionMountPath);
export const deviceService = new Device(deviceMountPath);
export const dealService = new Deal(dealMountPath);
export const contactService = new Contact(contactMountPath);
export const contactUsService = new ContactUs(contactUsMountPath);
export const authService = new Auth(authMountPath);
export const sessionService = new Session(sessionMountPath);
// Repeat for other entities
